import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../actions/loginAndRegisterActions';
import ErrorResponse from '../../components/ErrorResponse';
import LinkButton from '../../components/LinkButton';
import ViewWrapper, { FormWrapper } from '../../components/ViewWrapper';
import logo from '../../img/Airthings_Favicon.png';
import { Store } from '../../reducers';
import { RequestType } from '../../reducers/requestReducer';
import styles from './IframeLogin.module.scss';

type IframeAuthorizationEvent = {
    data: {
        authorization: boolean;
        username: string;
        password: string;
    };
};

export const manualLogin = (): string => window.location.search.replace('iframe=true', 'iframe=false');

const IframeLoginContainer = (): JSX.Element => {
    const { t: txt } = useTranslation();
    const dispatch = useDispatch();
    const { loading, error } = useSelector((state: Store) => state.requests[RequestType.Login]);
    const [showManualButton, setShowManualButton] = useState(false);

    const receiveAuthMessageListener = (event: IframeAuthorizationEvent): void => {
        if (event.data.authorization && event.data.username && event.data.password) {
            dispatch(login(event.data.username, event.data.password));
        }
    };

    useEffect(() => {
        setTimeout(() => {
            setShowManualButton(true);
        }, 5000);
        window.addEventListener('message', receiveAuthMessageListener);
        window.parent.postMessage({ waitingForAuthorization: true }, '*');
    }, []);

    const onSubmit = (): void => {
        // do nothing
    };

    return (
        <ViewWrapper>
            <FormWrapper testAttr={'login-form'} onSubmit={onSubmit}>
                <img src={logo} className={styles.logo} alt={txt('Logo.AirthingsLogo')} />
                {error ? (
                    <ErrorResponse error={`ErrorCodes.${error.error}`} testAttr={'iframe-login-error'} />
                ) : (
                    <div className={styles.paragraph}>{txt(loading ? 'IFrame.LoggingIn' : 'IFrame.AuthWaiting')}</div>
                )}
                {((showManualButton && !loading) || error) && (
                    <LinkButton link={manualLogin()} label={'IFrame.AuthGotoManual'} />
                )}
            </FormWrapper>
        </ViewWrapper>
    );
};

export default IframeLoginContainer;
